import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const tableBox = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: { xs: "500px", sm: "400px" },
});

export const homeButton = ({ breakpoints }: Theme) => ({
  bgcolor: colors.main,
  color: "white",
  m: 3,
  width: "140px",
  fontSize: "18px",
  fontWeight: "bold",
});
